import React, { useContext } from 'react';
import Style from './header.module.scss';
import { Button, AuthContext } from 'components/lib';

const LTDOfferBar = ({ subscription }) => {
  const coupons = subscription?.data?.coupons || [];
  const authContext = useContext(AuthContext);

  if (coupons.length === 0 || authContext?.user?.permission === 'client') return null;

  return (
    <div className={`${Style.info} ${Style.responsiveInfo}`}>
      <p>
        Last chance to upgrade your Lifetime benefits for $69
      </p>
      <Button
        variant="primary"
        text="Buy Now"
        action={() =>
          window.open(
            `https://deal.salesblink.io/ltd-upgrade/landing?current=${coupons?.length}&email=${authContext?.user?.email}&account_id=${authContext?.user?.account_id}`,
            '_blank'
          )
        }
        style={{ fontSize: 14, padding: '4px 7px', minWidth: 'fit-content' }}
      />
    </div>
  );
};

export default LTDOfferBar;
